angular.module('bmsApp.dashboard')
	.controller('DashboardTicketSaveCtrl', function ($scope,
													 $state,
													 $q,
													 $timeout,
													 ngTableParams,
													 Upload,
													 $ngBootbox,
													 SMScheduleSvc,
													 SMJobSvc,
													 notify,
													 ActivitySvc,
													 TGProductSvc,
													 CustomerSvc,
													 TicketSvc,
													 FranchiseSvc) {

		var self = this;


		self.methods = {
			init: init,
			uploadFiles: uploadFiles,
			submit: submit,
			closeTicket: closeTicket
		};

		function init() {
			self.form = {
				note: {
					note: ''
				}
			};
			self.uploadedFiles = [];
			var promises = {
				franchise: FranchiseSvc.read(),
				ticket: TicketSvc.read($state.params.ticketId)
			};
			$q.all(promises)
				.then(function (responses) {
					self.ticket = responses.ticket.data.ticket;
					self.franchise = responses.franchise.data.franchise;
				});
		}

		function uploadFiles(files) {
			self.uploadInProgress = true;
			var promises = [];
			if (files && files.length) {
				angular.forEach(files, function (file) {
					promises.push(Upload.upload({
						url: 'api/ticket/upload',
						data: {
							file: file
						}
					}));
				});

				$q.all(promises)
					.then(function (responses) {
						angular.forEach(responses, function (response) {
							self.uploadedFiles.push(response.data.file);
						});
						$timeout(function () {
							self.isDragging = false;
							self.uploadInProgress = false;
						});
					}, function (errors) {
						$timeout(function () {
							self.isDragging = false;
							self.uploadInProgress = false;
						});

					});
			}
		}

		function submit() {
			var params = {
				ticketId: self.ticket.id,
				form: self.form,
				files: self.uploadedFiles,
			};
			TicketSvc.saveNote(params)
				.then(function (response) {
					notify({
						message: 'Note successfully added to ticket'
					});
					init();
				});
		}

		function closeTicket() {
			$ngBootbox.confirm('Are you sure you wish to close this ticket?')
				.then(function () {
					var params = {
						ticketId: self.ticket.id
					};
					TicketSvc.closeTicket(params).then(function(response) {
						notify({
							message: 'Ticket closed successfully'
						});
						$state.go('main.dashboard.tickets');
					});
				});
		}


	});